import { useEffect, useState } from 'react';
import { DefaultOptionType } from 'antd/lib/select';
import { notification } from 'antd';
import { useApiFetch } from './api/useApiFetch';
import { IListResponse } from '../types/api/responses';

interface ICall {
    id: number;
    meeting_date: string | null;
    'master.fio': string | null;
    'product.name': string;
    'orderStatus.name': string;
    closed_at: string | null;
    serial_number_for_office: string;
    order_status_id: number;
    call_date: string | null;
    call_time: string | null;
    'lastCall.user.fio': string | null;
    'lastCall.commentary': string | null;
    'lastCall.prozvonStatus.name': string | null;
    'prozvonStatus.id': number | null;
    calls_count: number;
    calls_count_hint: string | null;
    deposit: number | null;
}

interface IUseCallFormParams {
    id?: number | string;
    withPhone: boolean;
}

export const useCallForm = ({ withPhone, id }: IUseCallFormParams) => {
    const api = useApiFetch();
    const [data, setData] = useState<ICall>();
    const [loading, setLoading] = useState(false);
    const [phone, setPhone] = useState<string>();
    const [phoneLoading, setPhoneLoading] = useState(false);
    const [statuses, setStatuses] = useState<DefaultOptionType[]>([]);
    const [amount, setAmount] = useState<number>();
    const [amountLoading, setAmountLoading] = useState(false);

    const getAmount = async () => {
        setAmountLoading(true);
        const res = await api.fetchData<number>(`/calls/form/${id}/amount`, 'get', true);
        if (typeof res.data === 'number') {
            setAmount(res.data);
        }
        setAmountLoading(false);
    };

    const getData = async () => {
        setLoading(true);
        const res = await api.fetchData<ICall>(`/calls/form/${id}`, 'get', true);
        if (res.data instanceof Object) {
            setData(res.data);
        }
        if (withPhone) {
            await getPhone();
        }
        setLoading(false);
    };

    const getPhone = async () => {
        setPhoneLoading(true);
        const res = await api.fetchData<string>(`/calls/form/${id}/phone`, 'get', true);
        if (res.success && typeof res.data === 'string') {
            setPhone(res.data);
        } else {
            notification.error({ message: res.message });
        }
        setPhoneLoading(false);
    };

    const getStatuses = async () => {
        const res = await api.fetchData<IListResponse<{ id: number; name: string; }>>('/prozvon-statuses/list', 'post', true);
        if (res.data instanceof Object && Array.isArray(res.data.list)) {
            setStatuses(res.data.list.map((el) => ({
                label: el.name,
                value: el.id,
            })));
        }
    };

    useEffect(() => {
        getData();
    }, [id]);

    useEffect(() => {
        getStatuses();
    }, []);

    return {
        amount: {
            get: getAmount,
            value: amount,
            loading: amountLoading,
        },
        clear: () => {
            setPhone(undefined);
            setAmount(undefined);
        },
        formData: {
            values: data,
            loading,
        },
        phone: {
            get: getPhone,
            value: phone,
            loading: phoneLoading,
        },
        statuses: {
            values: statuses,
        },
    };
};
